import React, { Component } from "react";
import { Select, Spin } from "antd";
import { LabeledValue } from "antd/lib/select";
import Person from "./models/person";
import CommonUser from "../models/commonUser";
import AppService from "../service/app.service";
import "./style.css";
import Item from "antd/lib/list/Item";
const { Option } = Select;
interface iProps {
  defaultValue?: Person[];
  value?: Person[];
  allowClear?: boolean;
  placeholder?: string;
  url?: string;
  userType?: string;
  onChange?: (value: Person[]) => void;
  params?: any;
}
interface iState {
  options: Person[];
  fetching: boolean;
}
export default class UserSelect extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    options: [],
    fetching: false,
  };
  search = async (searchText = "") => {
    let { url = "", userType = "TEACHER,STUDENT", params = {} } = this.props;
    let options = await this.appService.getPersonData({
      url,
      searchText,
      userType,
      params,
    });
    this.setState({ options, fetching: false });
  };
  get defaultValue() {
    let { defaultValue = [] } = this.props;
    return defaultValue.map((person: any) => ({
      value: person.userId,
      label: person.fullname|| person.fullName,
      key: JSON.stringify(person),
    }));
  }
  get value() {
    let { value = [] } = this.props;
    return value.map((person: any) => ({
      value: JSON.stringify(person),
      label: person.fullname|| person.fullName,
      key: JSON.stringify(person),
    }));
  }
  componentDidMount() {
    this.search();
  }
  handleChange = async (selectedItems: LabeledValue[]) => {

    let personList = selectedItems.map(
      (item) => JSON.parse(item.key)?.fullname?new Person(JSON.parse(item.key)):new Person({...JSON.parse(item.key),fullname:JSON.parse(item.key).fullName})
    );
    this.props.onChange(personList);
    if (selectedItems.length == 0) {
      this.search();
    }
  };
  handleSearch = async (searchText) => {
    await this.setState({ fetching: true });
    this.search(searchText);
  };
  handleBlur = () => {
    this.search();
  };
  render() {
    const { placeholder = "请选择", allowClear = true } = this.props;
    const { fetching, options } = this.state;
    const filteredOptions = options.filter(
      (o) => !this.value.some((selectedItem) => selectedItem.value == o.userId)
    );
    return (
      <Select
        labelInValue={true}
        defaultValue={this.defaultValue}
        value={this.value}
        allowClear={allowClear}
        onSearch={this.handleSearch}
        onBlur={this.handleBlur}
        mode="multiple"
        dropdownClassName="user-select"
        placeholder={placeholder}
        dropdownMatchSelectWidth={false}
        filterOption={false}
        onChange={this.handleChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: "100%" }}
      >
        {filteredOptions.map((item: Person) => (
          <Option label={item.fullname} key={JSON.stringify(item)}>
            {/* <MyIcon type={`icon${item.userType.toLowerCase()}`} /> */}
            {item.fullname}（{item.no}）
          </Option>
        ))}
      </Select>
    );
  }
}
